import { Link } from "react-router-dom";

export const AuthLinks = () => (
  <div>
    <div className="mx-auto flex max-w-[255px] justify-between">
      <Link
        to="https://fbtc.co.uk/Terms/Index"
        target="_blank"
        className="text-button text-black-54 underline underline-offset-[3px] hover:no-underline"
      >
        Terms and conditions
      </Link>
      <Link
        to="https://fbtc.co.uk/Terms/Privacy"
        target="_blank"
        className="text-button text-black-54 underline underline-offset-[3px] hover:no-underline"
      >
        Privacy policy
      </Link>
    </div>
    <div className="pt-4 text-center text-200 font-light text-black-54">
      © 2025 FBTC Accountancy Services. All rights reserved.
    </div>
  </div>
);
